import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { InjectionToken } from "tsyringe";

import { GwI18n } from "./GwI18n/GwI18n";
import I18nCriticalLoaderFactory from "./GwI18n/I18nCriticalLoaderFactory";
import TranslationsApiService from "./TranslationsApiService/TranslationsApiService";

export const gwI18nToken = Symbol("i18nToken") as InjectionToken<GwI18n>;

export const i18nCriticalLoaderFactoryToken = Symbol(
    "i18nCriticalLoaderFactoryToken"
) as InjectionToken<I18nCriticalLoaderFactory>;

export const translationsApiClientToken = Symbol(
    "translationsApiClientToken"
) as InjectionToken<ApiClientInterface>;

export const translationsApiServiceToken = Symbol(
    "translationsApiServiceToken"
) as InjectionToken<TranslationsApiService>;
